export default __webpack_public_path__ + "static/media/close.0a826c04.svg";